import _ from "lodash";
import { useEffect, useState } from "react";
import { useAccount } from "@/hooks/useAccount";
import BigNumber from "bignumber.js";
import { SUPPORT_CHAIN_IDS } from "@/libs/PrivyProvider";

export const useGasPrice = () => {
  const { chain, publicClient } = useAccount();

  const [currentGasPrice, setCurrentGasPrice] = useState<number>(0);

  useEffect(() => {
    const fetch = async () => {
      const gasPrice = await publicClient.getGasPrice();

      setCurrentGasPrice(
        new BigNumber(gasPrice.toString() ?? "1078").div(1e9).toNumber()
      );

      // if (chain?.id === SUPPORT_CHAIN_IDS.BotanixTestnet) {
      //   // setCurrentGasPrice(0.0011);
      //   setCurrentGasPrice(0.0065); // TODO recheck, privy
      // } else {
      //   // const data: any = await estimateFeesPerGas(wagmiConfig);
      //   // const price = BigNumber(data?.gasPrice?.toString() ?? "0").div(1e9);
      //   // setCurrentGasPrice(price.toNumber());
      //   setCurrentGasPrice(0); // TODO privy
      // }
    };

    const idt = setTimeout(fetch, 300);
    return () => clearTimeout(idt);
  }, [chain?.id, publicClient]);

  return {
    currentGasPrice,
  };
};
